import React from 'react';
import cn from 'classnames';
import s from './PageTitle.module.scss';

const PageTitle = ({ children, auth, className }) => (
  <h1 className={cn(auth ? s.authPageTitle : s.appPageTitle, className)}>{children}</h1>
);

export default PageTitle;
